export default __webpack_public_path__ + "static/media/device-info.7add2e49.png";